import React, { Component } from "react";
import { Button, Form, Image, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import configData from "../config.json";
import "./Abha.css";

export default class AbhaProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      requestId: sessionStorage.getItem("requestId"),
      AbhaProfile: { mobile: "" },
      abhanumber: "",
      aadharNumber: "",
      isSubmitting: false,
      getAbhaQrCode: false,
      qrCodePaths: [],
      isSubmittingQrcode: false,
      updateprofile: false,
      mobileNumber: "",
      mobileotp: ["", "", "", "", "", ""],
      resendTimer: 60,
      resendEnabled: false,
      resendIntervalId: null,
      showMobileEdit: false,
      showOtpModal: false,
      emailId: "",
      showEmailEdit: false,
      address: "",
      showAddressEdit: false,
      showOtp: false,
    };
  }

  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.success(msg);
    }
  };

  componentDidMount() {
    this.ResponseHandler();
    if (!sessionStorage.getItem("resendOtpUpdateMobileCount")) {
      sessionStorage.setItem("resendOtpUpdateMobileCount", "0");
    }
  }

  componentWillUnmount() {
    if (this.state.resendIntervalId) {
      clearInterval(this.state.resendIntervalId);
    }
    this.startResendCountdown();
  }

  startResendCountdown = () => {
    this.setState({
      resendEnabled: false,
      resendOtpUpdateMobileCount:
        parseInt(sessionStorage.getItem("resendOtpUpdateMobileCount")) || 0,
      resendTimer: 60,
    }); // Start with 5 minutes
    const intervalId = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.resendTimer <= 1) {
          clearInterval(this.state.resendIntervalId);
          return { resendEnabled: true, resendTimer: 0 }; // Re-enable button after timer ends
        }
        return { resendTimer: prevState.resendTimer - 1 };
      });
    }, 1000);
    this.setState({ resendIntervalId: intervalId });
  };

  ResponseHandler = () => {
    var formData = new FormData();
    formData.append("requestId", this.state.requestId);
    fetch(configData.api_url + "C_Abhadetails/retriverequestId", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success" && data.detail) {
          const abhaProfile = data.detail;
          if (abhaProfile) {
            this.setState({ 
              AbhaProfile: abhaProfile,
              emailId: abhaProfile.emailId || "",
              address: abhaProfile.address || ""
            });
          } 
        }
      });
  };

  HandleClick = () => {
    this.setState({ isSubmitting: true });
  
    var formData = new FormData();
    formData.append("requestId", this.state.requestId);
  
    fetch(configData.api_url + "C_Abhadetails/retriveAbhacard", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message);
  
        if (data.status === "success") {
          this.handleDownloadPng(data.details);
        }
  
        this.setState({ isSubmitting: false });
      })
      .catch(() => {
        this.showToast("Error retrieving ABHA card", "error");
        this.setState({ isSubmitting: false });
      });
  };
  HandleQrcodeClick = () => {
    this.setState({ getAbhaQrCode: true });
  
    const formData = new FormData();
    formData.append("requestId", this.state.requestId);
  
    fetch(configData.api_url + "C_Abhadetails/getAbhaQrCode", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message);
  
        if (data.status === "success") {
          this.handleDownloadPng(data.details); 
          // Works for QR & card
        }
  
        this.setState({ getAbhaQrCode: false });
      })
      .catch(() => {
        this.showToast("Something went wrong while fetching QR code", "error");
        this.setState({ getAbhaQrCode: false });
      });
  };
  
  // HandleQrcodeClick = () => {
  //   this.setState({ getAbhaQrCode: true });
  //   const formData = new FormData();
  //   formData.append("requestId", this.state.requestId);

  //   fetch(configData.api_url + "C_Abhadetails/getAbhaQrCode", {
  //     method: "POST",
  //     mode: "cors",
  //     body: formData,
  //   })
  //     .then((response) => response.json())
  //     .then((data) => {
  //       this.showToast(data.message);
  //       if (data.status === "success") {
  //         this.handleDownloadPng(data.details);
  //       }
  //       this.setState({ getAbhaQrCode: false });
  //     })
  //     .catch((error) => {
  //       this.showToast("Something went wrong while fetching QR code.");
  //       this.setState({ getAbhaQrCode: false });
  //     });
  // };

handleDownloadPng = async (url) => {
 
  try {
    
    const requestId = sessionStorage.getItem("requestId") || "file";

    // Fetch file as blob
    const response = await fetch(url);
    if (!response.ok) throw new Error("Network response was not ok");

    const blob = await response.blob();

    // Create temporary URL
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;

    // Preserve file extension from blob type
    const ext = blob.type.split("/")[1] || "png"; // fallback
    link.download = `${requestId}.${ext}`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Release memory
    window.URL.revokeObjectURL(downloadUrl);
  } catch (error) {
    console.error("Download failed:", error);
  }
};
  // Mobile Number Update Functions
  HandleMobileClick = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ mobileNumber: fieldValue });
  };

  onKeyDown = (e) => {
    if (e.key === " ") {
      e.preventDefault();
      toast.error("Spaces are not allowed.");
    }
  };

  HandleMobileUpdate = (e) => {
    const { mobileNumber } = this.state;
    if (mobileNumber.trim() === "") {
      this.showToast("Mobile number is required.", "error");
      return;
    }
    const mobileRegex = /^\d{10}$/;
    if (!mobileRegex.test(mobileNumber)) {
      this.showToast(
        "Mobile Number must be 10 digits long and contain only numbers.",
        "error"
      );
      return;
    }
     var formData = new FormData();
    formData.append("mobileNumber", mobileNumber);
    formData.append("requestId", sessionStorage.getItem("requestId"));
    fetch(configData.api_url + "C_Abhadetails/updateMobileinAbha", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
            sessionStorage.setItem("mobile", this.state.mobileNumber);
            this.setState({ 
              showOtpModal: true,
              showMobileEdit: false,
              mobileotp: ["", "", "", "", "", ""] 
              // Clear any existing OTP
            });
            
            this.startResendCountdown();
             // Redirect to the same page to refresh data
             } 
      })
    
  };

  formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(remainingSeconds).padStart(2, "0")}`;
  };

  ResendOTP = (e) => {
    e.preventDefault();
    let resendCount =
      parseInt(sessionStorage.getItem("resendOtpUpdateMobileCount")) || 0;
  
    if (resendCount >= 2) {
      this.showToast("Resend OTP not working.");
      return;
    }
  
    const formData = new FormData();
    formData.append("requestId", this.state.requestId);
  
    fetch(configData.api_url + "C_Abhadetails/resendMobileOtp", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
      
        if (data.details?.error?.message) {
           this.showToast(data.details.error.message,"error");
          return;
        }
  
        if (data.status === "success") {
          this.showToast(data.message, "success");
          sessionStorage.setItem("resendOtpUpdateMobileCount", resendCount + 1);
          clearInterval(this.state.resendIntervalId);
          this.startResendCountdown();
        } else {
          const errorMsg = data.message || "OTP resend failed. Please try again.";
           this.showToast(errorMsg, "error");
        }
      })
      .catch((error) => {
        console.error("Fetch Error:", error);
         this.showToast("Something went wrong. Please try again later.");
      });
  };

  handleOtpVerification = (e) => {
    e.preventDefault();
    const mobileotp = this.state.mobileotp.join("");

    sessionStorage.setItem("mobileNumber", this.state.mobileNumber);
    var formData = new FormData();

    formData.append("mobileotp", mobileotp);
    formData.append("requestId", sessionStorage.getItem("requestId"));
    this.setState({ resendButtonVisible: true });
    fetch(configData.api_url + "C_Abhadetails/submitMobileOtpinAbha", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          sessionStorage.setItem("mobileNumber", this.state.mobileNumber);
          sessionStorage.setItem("resendOtpUpdateMobileCount", "");
          this.closeOtpModal();
          window.location.href="/abhaprofile";
          this.setState({
            resendOtpUpdateMobileCount: "",
          });
        }
      });
  };

  closeOtpModal = () => {
    this.setState({
      showOtpModal: false,
      mobileotp: ["", "", "", "", "", ""],
      mobileNumber: "",
      showOtp: false,
    });
    // Clear the resend countdown timer
    if (this.state.resendIntervalId) {
      clearInterval(this.state.resendIntervalId);
    }
    // Reset resend timer state
    this.setState({
      resendTimer: 60,
      resendEnabled: false,
      resendIntervalId: null,
    });
  };

  handleOtpChange = (e, index) => {
    const { value } = e.target;
    const newOtp = [...this.state.mobileotp];
    newOtp[index] = value.replace(/\D/, "").charAt(0) || "";
    this.setState({ mobileotp: newOtp }, () => {
      if (value && index < 5) {
        this[`otpInput${index + 1}`]?.focus();
      }
    });
  };
  handleOtpKeyDown = (e, index) => {
    // Handle backspace to go to previous input
    if (e.key === "Backspace" && !this.state.mobileotp[index] && index > 0) {
      const prevInput = this[`otpInput${index - 1}`];
      if (prevInput) {
        prevInput.focus();
      }
    }
    // Handle Enter key to verify OTP
    if (e.key === "Enter") {
      this.handleOtpVerification();
    }
  };
  verifyOtp = () => {
    const otp = this.state.mobileotp.join("");
    if (otp.length !== 6) {
       this.showToast("Please enter a valid 6-digit OTP.");
      return;
    }
  
    const formData = new FormData();
    formData.append("mobileOtp", otp);
    formData.append("requestId", sessionStorage.getItem("requestId"));
  
    fetch(configData.api_url + "C_Abhadetails/verifyMobileOtp", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
           this.showToast("Mobile number verified successfully!");
          this.setState({ showOtpModal: false });
          this.ResponseHandler(); // Refresh data
        } else {
           this.showToast(data?.details?.error?.message || data.message || "OTP verification failed.");
        }
      })
      .catch((err) => {
        console.error("OTP Verification Error:", err);
         this.showToast("Something went wrong during OTP verification.");
      });
  };
  
  // Email Update Functions
  HandleEmailUpdate = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ emailId: fieldValue });
  };

  HandleEmailSubmit = (e) => {
    const { emailId } = this.state;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
    if (!emailId.trim()) {
      this.showToast("Email cannot be empty.", "error");
      return;
    }

    if (!emailRegex.test(emailId)) {
      this.showToast("Please enter a valid email address.", "error");
      return;
    }

    var formData = new FormData();
    formData.append("emailId", emailId);
    formData.append("requestId", sessionStorage.getItem("requestId"));
    
    fetch(configData.api_url + "C_Abhadetails/updateEmailinAbha", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({ showEmailEdit: false });
          this.ResponseHandler(); // Refresh profile data
        }
      });
  };

  // Address Update Functions
  HandleAddressUpdate = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ address: fieldValue });
  };

  HandleAddressSubmit = (e) => {
    const { address } = this.state;
    const trimmedAddress = address.trim();

    if (!trimmedAddress) {
      this.showToast("Postal address is required.", "error");
      return;
    }
    if (trimmedAddress.length < 5) {
      this.showToast("Postal address must be at least 5 characters long.", "error");
      return;
    }
    
    const validAddressRegex = /^[A-Za-z0-9\s/\-&,.\u0900-\u097F]+$/;
    if (!validAddressRegex.test(trimmedAddress)) {
      this.showToast("Postal address contains invalid characters.", "error");
      return;
    }

    var formData = new FormData();
    formData.append("address", this.state.address);
    formData.append("requestId", sessionStorage.getItem("requestId"));
    
    fetch(configData.api_url + "C_Abhadetails/updatepostalAddress", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({ showAddressEdit: false });
          this.ResponseHandler(); // Refresh profile data
        }
      });
  };

  render() {
    const {
      mobileNumber,
      mobileotp,
      emailId,
      showOtp,
      address,
      showMobileEdit,
      showEmailEdit,
      showAddressEdit,
      showOtpModal,
      resendEnabled,
      resendTimer,
    } = this.state;

    return (
      <div>
        <div className="row widget_BG widget_BG_grid d-flex m-0 mt-2">
          <div className="col-md-4 col-sm-12 col-lg-4 abhaprofilediv">
            <Form.Group>
              <Form.Label>First Name</Form.Label>
              <Form.Control
                type="text"
                name="firstName"
                id="firstName"
                disabled
                value={this.state.AbhaProfile.firstName}
                className="form-control"
              />
            </Form.Group>
          </div>
          
          <div className="col-md-4 col-sm-12 col-lg-4 abhaprofilediv">
            <Form.Group>
              <Form.Label>Middle Name</Form.Label>
              <Form.Control
                type="text"
                name="middleName"
                id="middleName"
                disabled
                value={this.state.AbhaProfile.middleName}
                className="form-control"
              />
            </Form.Group>
          </div>
          
          <div className="col-md-4 col-sm-12 col-lg-4 abhaprofilediv">
            <Form.Group>
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                type="text"
                name="lastName"
                id="lastName"
                value={this.state.AbhaProfile.lastName}
                disabled
                className="form-control"
              />
            </Form.Group>
          </div>

          <div className="col-md-4 abhaprofilediv datepick">
            <Form.Group>
              <Form.Label>Date Of Birth</Form.Label>
              <div ClassName="custom-calendar">
                <Form.Control
                  type="text"
                  name="dob"
                  id="dob"
                  value={this.state.AbhaProfile.dob}
                  disabled
                  className="form-control"
                />
              </div>
            </Form.Group>
          </div>
          
          <div className="col-md-4 col-sm-12 col-lg-4 abhaprofilediv">
            <Form.Group controlId="policyType">
              <Form.Label>Gender</Form.Label>
              <Form.Control
                as="select"
                disabled
                value={this.state.AbhaProfile.gender}
              >
                <option value="">Select</option>
                <option value="M">Male</option>
                <option value="F">Female</option>
                <option value="Tr">Transgender</option>
              </Form.Control>
            </Form.Group>
          </div>

          {/* Mobile Number Section */}
          <div className="col-md-4 col-sm-12 col-lg-4 abhaprofilediv">
            <Form.Group>
              <Form.Label>Mobile Number</Form.Label>
              {!showMobileEdit ? (
                <div className="d-flex">
                  <Form.Control
                    type="text"
                    value={this.state.AbhaProfile.mobileNumber}
                    disabled
                  />
                  <Button
                    variant="primary"
                    onClick={() => this.setState({ showMobileEdit: true, mobileNumber: "" })}
                    style={{ marginLeft: "5px" }}
                  >
                    Update
                  </Button>
                </div>
              ) : (
                <div>
                  <div className="d-flex">
                    <Form.Control
                      type="text"
                      name="mobileNumber"
                      onChange={this.HandleMobileClick}
                      maxLength={10}
                      onKeyDown={this.onKeyDown}
                      className="form-control"
                      value={mobileNumber}
                      placeholder="Enter new mobile number"
                    />
                    <Button
                      variant="success"
                      onClick={this.HandleMobileUpdate}
                      style={{ marginLeft: "5px" }}
                    >
                      Submit
                    </Button>
                    <Button
                      variant="secondary"
                      onClick={() => this.setState({ 
                        showMobileEdit: false, 
                        showOtpModal: false,
                        mobileNumber: "",
                        mobileotp: ["", "", "", "", "", ""]
                      })}
                      style={{ marginLeft: "5px" }}
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              )}
            </Form.Group>
            
          </div>
          <div className="col-md-4 col-sm-12 col-lg-4 abhaprofilediv">
            <Form.Group>
              <Form.Label>ABHA Number</Form.Label>
              <div ClassName="custom-calendar">
                <Form.Control
                  type="text"
                  name="abhanumber"
                  id="abhanumber"
                  value={this.state.AbhaProfile.abhanumber}
                  disabled
                  className="form-control"
                />
              </div>
            </Form.Group>
          </div>
          
          <div className="col-md-4 abhaprofilediv datepick">
            <Form.Group>
              <Form.Label>ABHA Address</Form.Label>
              <div ClassName="custom-calendar">
                <Form.Control
                  type="text"
                  name="phrAddress"
                  id="phrAddress"
                  value={this.state.AbhaProfile.phrAddress}
                  disabled
                  className="form-control"
                />
              </div>
            </Form.Group>
          </div>
          
          <div className="col-md-4 col-sm-12 col-lg-4 abhaprofilediv">
            <Image
              style={{
                width: "100px",
                marginLeft: "5px",
                marginTop: "10px",
              }}
              src={"data:image/jpeg;base64," + this.state.AbhaProfile.photo}
              alt="image"
            />
          </div>

          {/* Email Section */}
          <div className="col-md-4 col-sm-12 col-lg-4 abhaprofilediv">
            <Form.Group>
              <Form.Label>Email-Id</Form.Label>
              {!showEmailEdit ? (
                <div className="d-flex">
                  <Form.Control
                    type="text"
                    value={this.state.AbhaProfile.emailId}
                    disabled
                  />
                  <Button
                    variant="primary"
                    onClick={() => this.setState({ showEmailEdit: true, emailId: this.state.AbhaProfile.emailId || "" })}
                    style={{ marginLeft: "5px" }}
                  >
                    Update
                  </Button>
                </div>
              ) : (
                <div className="d-flex">
                  <Form.Control
                    type="email"
                    name="emailId"
                    onChange={this.HandleEmailUpdate}
                    className="form-control"
                    value={emailId}
                    placeholder="Enter email address"
                  />
                  <Button
                    variant="success"
                    onClick={this.HandleEmailSubmit}
                    style={{ marginLeft: "5px" }}
                  >
                    Submit
                  </Button>
                  <Button
                    variant="secondary"
                    onClick={() => this.setState({ showEmailEdit: false })}
                    style={{ marginLeft: "5px" }}
                  >
                    Cancel
                  </Button>
                </div>
              )}
            </Form.Group>
          </div>

          {/* Address Section */}
          <div className="col-md-4 col-sm-12 col-lg-4 abhaprofilediv">
            <Form.Group>
              <Form.Label>Address</Form.Label>
              {!showAddressEdit ? (
                <div className="d-flex">
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={this.state.AbhaProfile.address}
                    disabled
                  />
                  <Button
                    variant="primary"
                    onClick={() => this.setState({ showAddressEdit: true, address: this.state.AbhaProfile.address || "" })}
                    style={{ marginLeft: "5px" }}
                  >
                    Update
                  </Button>
                </div>
              ) : (
                <div>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="address"
                    onChange={this.HandleAddressUpdate}
                    className="form-control"
                    value={address}
                    placeholder="Enter address"
                  />
                  <div className="d-flex mt-2">
                    <Button
                      variant="success"
                      onClick={this.HandleAddressSubmit}
                      style={{ marginRight: "5px" }}
                    >
                      Submit
                    </Button>
                    <Button
                      variant="secondary"
                      onClick={() => this.setState({ showAddressEdit: false })}
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              )}
            </Form.Group>
          </div>

          <div className="col-md-4 col-sm-12 col-lg-4 abhaprofilediv">
            <Form.Group>
              <Form.Label>Pincode</Form.Label>
              <Form.Control
                type="text"
                name="pinCode"
                id="pinCode"
                maxLength={6}
                value={this.state.AbhaProfile.pinCode}
                disabled
              />
            </Form.Group>
          </div>
          
          <div className="col-md-4 col-sm-12 col-lg-4 abhaprofilediv">
            <Form.Group>
              <Form.Label>District</Form.Label>
              <Form.Control
                type="text"
                name="districtName"
                id="districtName"
                maxLength={10}
                value={this.state.AbhaProfile.districtName}
                disabled
              />
            </Form.Group>
          </div>
          
          <div className="col-md-4 col-sm-12 col-lg-4 abhaprofilediv">
            <Form.Group>
              <Form.Label>State</Form.Label>
              <Form.Control
                type="text"
                name="stateName"
                id="stateName"
                value={this.state.AbhaProfile.stateName}
                disabled
              />
            </Form.Group>
          </div>
          
          <div className="col-md-4 col-sm-12 col-lg-4 abhaprofilediv">
            <Form.Group>
              <Form.Label>ABHA Status</Form.Label>
              {this.state.AbhaProfile.abhaStatus === "ACTIVE" ? (
                <i
                  className="bi bi-check"
                  style={{
                    color: "green",
                    fontSize: "50px",
                    marginLeft: "5px",
                  }}
                />
              ) : this.state.AbhaProfile.abhaStatus === "INACTIVE" ? (
                <i
                  className="bi bi-x"
                  style={{
                    color: "red",
                    fontSize: "1.2rem",
                    marginLeft: "5px",
                  }}
                />
              ) : null}
            </Form.Group>
          </div>
        </div>  
        
         <Modal show={showOtpModal} onHide={this.closeOtpModal}>
            <Modal.Header closeButton>
              <Modal.Title>Verify OTP</Modal.Title>
            </Modal.Header>
              <Modal.Body>
              <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                  <div className="d-flex gap-2"
                          style={{ justifyContent: "center" }}
                        >
                          {this.state.mobileotp.map((digit, index) => (
                            <Form.Control
                              key={index}
                              type={this.state.showOtp ? "text" : "password"}
                              maxLength="1"
                              value={digit}
                              onChange={(e) => this.handleOtpChange(e, index)}
                              onKeyDown={(e) => this.handleOtpKeyDown(e, index)}
                              ref={(input) => (this[`otpInput${index}`] = input)}
                              style={{
                                textAlign: "center",
                              }}
                            />
                          ))}

                          <Button
                            variant="outline-secondary"
                            className={`rounded-0 bi ${
                              showOtp ? "bi-eye-slash" : "bi-eye"
                            }`}
                            onClick={() => this.setState({ showOtp: !showOtp })}
                          />
                        </div>
                        
              </div>
              <div  className="d-flex mt-3 row">
                          <div className="col">
                            {parseInt(
                              sessionStorage.getItem("resendOtpUpdateMobileCount")
                            ) >= 2 ? (
                              <div style={{ color: "red", fontWeight: "bold" }}>
                              You’ve reached the maximum resend attempts.
                            </div>
                            ) : (
                              <>
                              <Button
                                className="rounded-0 m-1"
                                variant="warning"
                                onClick={this.ResendOTP}
                                disabled={!resendEnabled}
                              >
                                Resend OTP{" "}
                                {!resendEnabled && `in ${this.formatTime(resendTimer)}`}
                              </Button>
                              <div style={{ fontSize: "12px", color: "gray" }}>
                              Resend OTP Send Only 2 Times in a Session You have used &nbsp;{" "}
                            {sessionStorage.getItem("resendOtpUpdateMobileCount")} out of 2.
                        </div>
                              </>
                            )}
                          </div>
                          <div className="col text-end">
                            <Button
                              className="rounded-0 m-1"
                              onClick={this.handleOtpVerification}
                            >
                              Verify OTP
                            </Button>
                          </div>
                        </div>
            </Modal.Body>
          </Modal>

        <div className="row widget_BG widget_BG_grid m-0 mt-2">
          <div className="col text-end">
       

            <Button
              className="rounded-0 m-1"
              onClick={this.HandleQrcodeClick}
              disabled={this.state.getAbhaQrCode}
            >
              {this.state.getAbhaQrCode ? "Fetching..." : "Get ABHA QR Code"}
            </Button>

            <Button
              className="rounded-0 m-1"
              disabled={this.state.isSubmitting}
              onClick={this.HandleClick}
            >
              {this.state.isSubmitting ? "Downloading ABHA Card..." : "Download ABHA"}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}